<template>
  <div v-if="is404">
    <page-not-found />
  </div>
  <div v-else>
    <other-errors :error="{ statusCode: 500 }" />
  </div>
</template>

<script lang="ts" setup>
import PageNotFound from '@/components/ErrorPages/PageNotFound.vue';
import OtherErrors from '@/components/ErrorPages/OtherErrors.vue';

defineProps<{ is404?: boolean }>();
</script>
